export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de pasos"])},
          "new_process_line_exec_step_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crear"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])}
        }
      }
    }
  })
}